<template>
   <div class="edit-group-course-master-details container-fluid">
        <div id="myNav" class="overlay overlay-overall-width-100Perc">
          <div class="overlay-content center-aligned-div white-porition-overlay-width-80Perc background-color-white margin-bottom-2Perc">
              <div class="row margin-bottom-2Perc">
                <div class="col-md-12 col-lg-12">
                  <div class="text-right close-text-font-style margin-right-1Point2Perc cursor-pointer" v-on:click="udpateCloseViewCourseDetailOverlay($event)">
                    <img src= "../assets/images/close.svg" class="img-responsive close-img-width-height margin-top-1Perc float-right" alt="close-icon">
                  </div>
                </div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Course Master:
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0px">
                  {{CourseTitleValue}}
                </div>
                <div class="font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-left-0px">
                  Sub-Title:
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0px">
                  {{CourseSubTitleValue}}
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Version:
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0px">
                  {{CourseVersionValue}}
                </div>
                <div class="font-weight-bold create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-left-0px">
                  Group Name:
                </div>
                <div class="col-md-3 col-lg-3 create-lesson-input-text-style text-align-left padding-left-0px">
                  {{GroupNameValue}}
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <!-- Display Title -->
              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Display Title:
                </div>
                <div class="col-md-3 col-lg-3 text-align-left padding-left-0px">
                  <input type="text" class="form-control" id="usr" v-model="displayTitleValue" :maxlength="display_title_maxLength">
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-left-0px">
                  Display Sub-Title:
                </div>
                <div class="col-md-3 col-lg-3 text-align-left padding-left-0px">
                  <input type="text" class="form-control" v-model="displaySubTitleValue" :maxlength="display_sub_title_maxLength">
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <!-- END Display Title -->
              <div class="row vertical-align margin-bottom-2Perc" v-if="getSelectedCourseMasterObj.CourseMasterType !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Anonymised R&D's:
                </div>
                <div class="col-md-1 col-lg-1 padding-left-0px text-align-left">
                  <input type="checkbox" v-model="anonymisedValue"/>
                </div>
                <div class="col-md-2 col-lg-2">
                </div>
                <div class="create-lesson-input-text-style col-lg-2 col-md-2 text-align-right">
                </div>
                <div class="col-md-3 col-lg-3 padding-left-0px text-align-left">
                  <div class="form-group text-align-left">
                    <div class="col-sm-4 padding-left-0px"></div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="getSelectedCourseMasterObj.CourseMasterType !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Custom Alert Message:
                </div>
                <div class="col-md-3 col-lg-3 text-align-left padding-left-0px">
                  <textarea class="form-control" rows="3" v-model="electiveAlertMessageValue" maxlength="1024" placeholder="Max 1024 characters" :disabled="electiveCourseValue || isM365Course"></textarea>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-left-0px">
                  Elective Course:
                </div>
                <div class="col-md-3 col-lg-3 text-align-left padding-left-0px">
                  <input type="checkbox" v-model="electiveCourseValue" :disabled="disableIsElectiveCheckBox"/>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>
              <div class="row vertical-align margin-bottom-2Perc" v-if="getSelectedCourseMasterObj.CourseMasterType !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Release Date:
                </div>
                <div class="col-md-3 col-lg-3 padding-left-0px">
                  <date-picker v-model="setDateValue" :config="config" :disabled="date === null || date === undefined || date === '' || date === 'null'"></date-picker>
                </div>
                <div class="create-lesson-input-text-style col-lg-2 col-md-2 text-align-right">
                  Expiry Days:
                </div>
                <div class="col-md-1 col-lg-1 padding-left-0px">
                  <input type="number" class="form-control" v-model="expiryDaysValue" min="0" max="999">
                </div>
                <div class="col-md-3 col-lg-3"></div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc" v-if="getSelectedCourseMasterObj.CourseMasterType !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  {{completionCriteriaTextLabel}}
                </div>
                <div class="col-md-1 col-lg-1 padding-left-0px">
                  <input type="number" class="form-control" v-model="setCompletionCriteriaForElectivesValue" min="0" max="100">
                </div>
                <div class="col-md-2 col-lg-2">
                </div>
                <div class="create-lesson-input-text-style col-lg-2 col-md-2 padding-left-0px text-align-right">
                </div>
                <div class="col-md-3 col-lg-3 text-align-left padding-left-0px">
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc" v-if="getSelectedCourseMasterObj.CourseMasterType !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Completion Criteria for Certificate:
                </div>
                <div class="col-md-1 col-lg-1 padding-left-0px">
                  <input type="number" class="form-control" v-model="setCompletionRateValue" min="1" max="100">
                </div>
                <div class="col-md-2 col-lg-2">
                </div>
                <div class="create-lesson-input-text-style col-lg-2 col-md-2 padding-left-0px text-align-right">
                  Automatically show certificates to Users:
                </div>
                <div class="col-md-3 col-lg-3 text-align-left padding-left-0px">
                  <input type="checkbox" v-model="allowViewCertificateValue" :disabled="!enableDisableCertificationOption"/>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc" v-if="getSelectedCourseMasterObj.CourseMasterType !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1">
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Upload Certificate:
                </div>
                <div class="col-md-3 col-lg-3 text-align-left padding-left-0px">
                  <p><input type="file" id="certificateFile" accept=".pdf" @change="enableOrDisableFileUrl" @blur="enableOrDisableFileUrl" @focus="enableOrDisableFileUrl"></p>
                  <p class="margin-top-1Perc cursor-pointer margin-Top-1Point5Perc" v-if="getCertificateUrlValue !== undefined && getCertificateUrlValue !== null && getCertificateUrlValue !== 'null' && getCertificateUrlValue !== ''">
                    <span class="text-decoration-underline">
                      <a class="text-color-blue " :href="getCertificateUrlValue" target="_blank">Download Existing</a>
                      </span> |
                    <span class="text-color-blue text-decoration-underline" @click="askUserConfrimation($event)">Delete certificate</span>
                  </p>
                </div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right padding-left-0px">
                  Certification Date:
                </div>
                <div class="col-md-3 col-lg-3 text-align-left padding-left-0px">
                  <input type="text" class="form-control" v-model="certificationDateValue">
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc" v-if="getSelectedCourseMasterObj.CourseMasterType !== constants.CourseType.RecommendationAssessment">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Enable Certification:
                </div>
                <div class="col-md-1 col-lg-1 padding-left-0px text-align-left">
                  <input type="checkbox" v-model="enableCeritificationValue" :disabled="!enableDisableCertificationOption"/>
                </div>
                <div class="col-md-2 col-lg-2">
                </div>
                <div class="create-lesson-input-text-style col-lg-2 col-md-2 padding-left-0px text-align-right">
                  Certificate Title:
                </div>
                <div class="col-md-3 col-lg-3 text-align-left padding-left-0px">
                  <input type="text" class="form-control" v-model="certificationTitleValue" :maxlength="constants.Certificate_Title_Max_Length">
                </div>
                <div class="col-md-1 col-lg-1 text-align-left">
                  <div class="tooltip1">
                    <img :src="iconInfo" alt="iconCopy" class="height-20Px width-20Px img-opacity cursor-pointer">
                    <span class="tooltiptext1">{{constants.Certificate_Title_Tooltip}}</span>
                  </div>
                </div>
              </div>

              <div class="row vertical-align margin-bottom-2Perc">
                <div class="col-md-1 col-lg-1"></div>
                <div class="create-lesson-input-text-style col-md-2 col-lg-2 text-align-right">
                  Enable Personalization:
                </div>
                <div class="col-md-1 col-lg-1 padding-left-0px text-align-left">
                  <input type="checkbox" v-model="enablePersonalizationValue"/>
                </div>
                <div class="col-md-2 col-lg-2">
                </div>
                <div class="create-lesson-input-text-style col-lg-2 col-md-2 text-align-right" v-if="electiveCourseValue">
                  Allow Self Enrollment:
                </div>
                <div class="col-md-3 col-lg-3 padding-left-0px text-align-left" v-if="electiveCourseValue">
                  <div class="form-group text-align-left">
                    <div class="col-sm-4 padding-left-0px">
                      <input type="checkbox" v-model="allowSelfEnrollmentValue"/>
                    </div>
                  </div>
                </div>
                <div class="col-md-1 col-lg-1"></div>
              </div>

              <div class="row margin-bottom-2Perc">
                <div class="col-md-5 col-lg-5">
                </div>
                <div class="col-md-2 col-lg-2">
                  <button class="btn btn-primary btn-block create-lesson-overlay-button-BG black-font-color" @click="updateGroupCourse">Update</button>
                </div>
                <div class="col-md-5 col-lg-5">
                </div>
              </div>
              <div class="row">
              </div>
          </div>
      </div>
      <loader></loader>
      <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postfixString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="deleteSelectedCertificate"></confirmation-alert>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
    </div>
</template>
<script>
import iconInfo from '../assets/images/iconinfoblue.png'
import Loader from '@/components/dashboard/Loader'
import { constants } from '@/utils/constants'
import AlertBox from '@/components/AlertOverlay'
import { groupService } from '@/server-util/group-service'
import { courseService } from '@/server-util/course-service'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import datePicker from 'vue-bootstrap-datetimepicker'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
export default {
  props: ['selectedCourseMasterObj'],
  name: 'edit-group-course-master-details',
  created: function () {
    this.getCourses()
    this.setDefaultValues()
  },
  data: function () {
    return {
      constants: constants,
      iconInfo: iconInfo,
      enableDisableCertificationOption: true,
      showConfirmationBox: false,
      prefixString: 'Are you sure you want to delete ',
      postfixString: '?',
      showAlertDialog: false,
      errorMsg: '',
      selectedCourseObj: null,
      isM365Course: false,
      enableCertification: false,
      groupCourseObj: {
        GroupCourseMasterId: '',
        GroupId: '',
        CourseMasterId: '',
        DisplayTitle: '',
        DisplaySubTitle: '',
        IsElective: false,
        AlertMessage: null,
        ReleaseTS: null,
        ExpiryDays: 1,
        CompletionRate: 100,
        CertificationDate: '',
        DisableCertification: false,
        Certificate: null,
        CertificateTitle: null,
        EnablePersonalization: false,
        Anonymised: false,
        SupportedPersonalizationLevels: '',
        CompletionCriteriaForElective: 100,
        AllowSelfEnrollment: false
      },
      completionCriteriaTextLabel: 'Completion Criteria for Electives:',
      SupportedPersonalizationLevelArr: [],
      display_title_maxLength: constants.Group_Course_Display_Title_Max_Length,
      display_sub_title_maxLength: constants.Group_Course_Display_Sub_Title_Max_Length,
      disableIsElectiveCheckBox: false,
      date: new Date(),
      config: {
        format: 'MM/DD/YYYY hh:mm:ss A',
        useCurrent: true,
        sideBySide: true,
        defaultDate: null
      }
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox,
    'date-picker': datePicker,
    'loader': Loader
  },
  methods: {
    enableOrDisableFileUrl (event) {
      var file = document.getElementById('certificateFile').files[0]
      if (this.getCertificateUrlValue === null) {
        if (file !== undefined && file !== 'undefined' && file !== null && file !== 'null' && file !== '') {
          this.enableDisableCertificationOption = true
        } else {
          this.groupCourseObj.DisableCertification = true
          this.enableCertification = false
          this.enableDisableCertificationOption = false
        }
      } else {
        this.enableDisableCertificationOption = true
      }
    },
    askUserConfrimation: function (event) {
      this.showConfirmationBox = true
      this.prefixString = 'Are you sure you want to delete '
      this.postfixString = 'added certificate?'
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button
      this.showConfirmationBox = value
    },
    deleteSelectedCertificate (value) {
      this.showConfirmationBox = false
      if (value) {
        var storeObj = this.$store
        if (storeObj.state.access_token !== undefined || storeObj.state.access_token !== '' || storeObj.state.access_token !== null) {
          this.$store.state.isLoading = true
          groupService.deleteGroupCourseCertificate(storeObj.state.access_token, this.groupCourseObj.GroupCourseMasterId)
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.groupCourseObj.Certificate.CertificateFile = null
                this.enableDisableCertificationOption = false
                // AK: Hide Spinner if its showing to user
                if (this.$store.state.isLoading === true) {
                  // this.showSpinner = false
                  this.$store.state.isLoading = false
                }
              } else {
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
                // AK: Hide Spinner if its showing to user
                if (this.$store.state.isLoading === true) {
                  // this.showSpinner = false
                  this.$store.state.isLoading = false
                }
              }
            }, errorObj => {
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
              // AK: Hide Spinner if its showing to user
              if (this.$store.state.isLoading === true) {
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            })
        } else {
          console.log('ACCESS TOKEN IS NOT FOUND HENCE DECLINE DELETE CERTIFICATE OPERATION')
        }
      }
    },
    validateRequiredFieldBeforeSubmit: function () {
      var pattern = /^-?\d+\.?\d*$/
      var certificateFile = document.getElementById('certificateFile').files[0]
      if (this.date === null && this.selectedCourseMasterObj.CourseMasterType === constants.CourseType.M365) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a release date.'
        return false
      } else if (((this.expiryDaysValue === undefined || this.expiryDaysValue === null || this.expiryDaysValue === '' || this.expiryDaysValue === 'null') && this.selectedCourseMasterObj.CourseMasterType === constants.CourseType.M365)) {
        this.showAlertDialog = true
        this.errorMsg = 'Expiry days must be a non empty digit value.'
        return false
      } else if ((this.expiryDaysValue !== undefined && this.expiryDaysValue !== null && this.expiryDaysValue !== '' && this.expiryDaysValue !== 'null' && !pattern.test(this.expiryDaysValue))) {
        this.showAlertDialog = true
        this.errorMsg = 'Expiry days must be a non empty digit value.'
        return false
      } else if (this.date === null && this.expiryDaysValue > 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a release date.'
        return false
      } else if (this.date !== null && (this.expiryDaysValue === undefined || this.expiryDaysValue === null || this.expiryDaysValue === 'null' || this.expiryDaysValue === '')) {
        this.showAlertDialog = true
        this.errorMsg = 'Expiry days must be a non empty digit value.'
        return false
      } else if (!pattern.test(this.expiryDaysValue)) {
        this.showAlertDialog = true
        this.errorMsg = 'Expiry days must be a non empty digit value.'
        return false
      } else if (this.date != null && this.expiryDaysValue <= 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Expiry days can\'t be less than 1.'
        return false
      } else if (this.date != null && this.expiryDaysValue > 999) {
        this.showAlertDialog = true
        this.errorMsg = 'Expiry days can\'t be more than 999.'
        return false
      } else if (certificateFile !== undefined && certificateFile !== 'undefined' && certificateFile !== null && !this.checkCertificateFileExtesion(document.getElementById('certificateFile').value)) {
        this.showAlertDialog = true
        this.errorMsg = 'Only .pdf file is allowed for uploading a certificate.'
        return false
      } else if ((this.certificationDateValue !== undefined && this.certificationDateValue !== null && this.certificationDateValue !== 'null' && this.certificationDateValue !== '') && ((certificateFile === undefined || certificateFile === 'undefined' || certificateFile === null || certificateFile === 'null' || certificateFile === '') && (this.getCertificateUrlValue === undefined || this.getCertificateUrlValue === 'undefined' || this.getCertificateUrlValue === null || this.getCertificateUrlValue === 'null' || this.getCertificateUrlValue === ''))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please upload a certificate or remove the certification date.'
        return false
      } else if ((this.certificationDateValue === undefined || this.certificationDateValue === null || this.certificationDateValue === 'null' || this.certificationDateValue === '') && ((certificateFile !== undefined && certificateFile !== 'undefined' && certificateFile !== null && certificateFile !== 'null' && certificateFile !== '') || (this.getCertificateUrlValue !== undefined && this.getCertificateUrlValue !== 'undefined' && this.getCertificateUrlValue !== null && this.getCertificateUrlValue !== 'null' && this.getCertificateUrlValue !== ''))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add a certification date or remove uploaded certificate.'
        return false
      } else if ((this.certificationTitleValue !== undefined && this.certificationTitleValue !== null && this.certificationTitleValue !== 'null' && this.certificationTitleValue !== '') && ((certificateFile === undefined || certificateFile === 'undefined' || certificateFile === null || certificateFile === 'null' || certificateFile === '') && (this.getCertificateUrlValue === undefined || this.getCertificateUrlValue === 'undefined' || this.getCertificateUrlValue === null || this.getCertificateUrlValue === 'null' || this.getCertificateUrlValue === ''))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please upload a certificate or remove the certificate title.'
        return false
      } else if ((this.certificationTitleValue === undefined || this.certificationTitleValue === null || this.certificationTitleValue === 'null' || this.certificationTitleValue === '') && ((certificateFile !== undefined && certificateFile !== 'undefined' && certificateFile !== null && certificateFile !== 'null' && certificateFile !== '') || (this.getCertificateUrlValue !== undefined && this.getCertificateUrlValue !== 'undefined' && this.getCertificateUrlValue !== null && this.getCertificateUrlValue !== 'null' && this.getCertificateUrlValue !== ''))) {
        this.showAlertDialog = true
        this.errorMsg = 'Please add a certificate title or remove uploaded certificate.'
        return false
      }
      return true
    },
    updateGroupCourse: function () {
      if (this.validateRequiredFieldBeforeSubmit()) {
        var storeObj = this.$store
        if (
          storeObj.state.access_token !== undefined || storeObj.state.access_token !== null || storeObj.state.access_token !== ''
          ) {
          if (this.date === undefined || this.date === null || this.date === '' || this.date === 'null') {
            this.groupCourseObj.ReleaseTS = null
            this.groupCourseObj.ExpiryDays = null
          } else {
            this.groupCourseObj.ReleaseTS = this.date
          }
          if (this.groupCourseObj.ExpiryDays === undefined || this.groupCourseObj.ExpiryDays === null || this.groupCourseObj.ExpiryDays === '' || this.groupCourseObj.ExpiryDays === 'null' || this.groupCourseObj.ExpiryDays === 0) {
            this.groupCourseObj.ReleaseTS = null
            this.groupCourseObj.ExpiryDays = null
          }
          // AK: Start showing Spinner
          this.$store.state.isLoading = true
          // AK: Change M365 course flag to false (for safer side)
          if (this.selectedCourseObj.Type === constants.CourseType.M365) {
            this.groupCourseObj.IsElective = false
          }
          // AK: If current course is elective / M365 then set alert message as null by default
          if (this.groupCourseObj.IsElective) {
            this.groupCourseObj.AlertMessage = null
          } else {
            this.groupCourseObj.AllowSelfEnrollment = false
          }
          if (this.certificationDateValue === undefined || this.certificationDateValue === 'undefined' || this.certificationDateValue === null || this.certificationDateValue === 'null' || this.certificationDateValue === '') {
            this.certificationDateValue = null
          }
          var certificateFile = document.getElementById('certificateFile').files[0]
          const formData = new FormData()
          formData.append('GroupCourseMasterId', this.groupCourseObj.GroupCourseMasterId)
          formData.append('GroupId', this.groupCourseObj.GroupId)
          formData.append('CourseMasterId', this.groupCourseObj.CourseMasterId)
          formData.append('DisplayTitle', this.groupCourseObj.DisplayTitle)
          formData.append('CompletionCriteriaForElective', this.groupCourseObj.CompletionCriteriaForElective)
          formData.append('DisplaySubTitle', this.groupCourseObj.DisplaySubTitle)
          formData.append('IsElective', this.groupCourseObj.IsElective)
          formData.append('AlertMessage', this.groupCourseObj.AlertMessage)
          formData.append('ReleaseTS', this.groupCourseObj.ReleaseTS)
          formData.append('ExpiryDays', this.groupCourseObj.ExpiryDays)
          formData.append('CompletionRate', this.groupCourseObj.CompletionRate)
          formData.append('AllowSelfEnrollment', this.groupCourseObj.AllowSelfEnrollment)
          formData.append('CertificationDate', this.groupCourseObj.CertificationDate)
          formData.append('CertificateTitle', this.groupCourseObj.CertificateTitle)
          formData.append('EnablePersonalization', this.groupCourseObj.EnablePersonalization)
          formData.append('Anonymised', this.groupCourseObj.Anonymised)
          console.log('updateGroupCourse ' + this.SupportedPersonalizationLevelArr)
          formData.append('SupportedPersonalizationLevels', this.SupportedPersonalizationLevelArr.toString())
          if ((certificateFile !== undefined && certificateFile !== 'undefined' && certificateFile !== null && certificateFile !== 'null' && certificateFile !== '') || (this.getCertificateUrlValue !== undefined && this.getCertificateUrlValue !== 'undefined' && this.getCertificateUrlValue !== null && this.getCertificateUrlValue !== 'null' && this.getCertificateUrlValue !== '')) {
            formData.append('CertificateFile', certificateFile)
            formData.append('DisableCertification', !this.enableCertification)
            formData.append('AllowView', this.groupCourseObj.AllowView)
          } else {
            formData.append('CertificateFile', null)
            formData.append('DisableCertification', true)
            formData.append('AllowView', false)
          }
          groupService
            .updateGroupCourse(
              storeObj.state.access_token,
              formData
            )
            .then(responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                this.$store.state.isLoading = false
                var objToPass = {
                  closeOverlay: true,
                  refreshList: true
                }
                this.$emit('closeEditGroupCourse', objToPass)
              } else {
                // AK: Hide Spinner
                // this.showSpinner = false
                this.$store.state.isLoading = false
                this.showAlertDialog = true
                this.errorMsg = 'Oops! Something went wrong. Please try again.'
              }
            }, errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              this.$store.state.isLoading = false
              this.showAlertDialog = true
              if (errorObj.response === undefined) {
                this.errorMsg = constants.No_Internet_Connection_Msg
              } else {
                this.errorMsg = errorObj.response.statusText
              }
            })
        } else {
          console.log(
            'Access Token is NULL hence declined CREATE NEW GROUP'
          )
        }
      }
    },
    checkCertificateFileExtesion: function (fileName) {
      var exts = ['.pdf']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    setDefaultValues: function () {
      this.groupCourseObj.GroupCourseMasterId = this.getSelectedCourseMasterObj.GroupCourseMasterId
      this.groupCourseObj.GroupId = this.getSelectedCourseMasterObj.GroupId
      this.groupCourseObj.CourseMasterId = this.getSelectedCourseMasterObj.CourseMasterId
      this.groupCourseObj.DisplayTitle = this.getSelectedCourseMasterObj.DisplayTitle !== undefined && this.getSelectedCourseMasterObj.DisplayTitle !== 'undefined' && this.getSelectedCourseMasterObj.DisplayTitle !== null && this.getSelectedCourseMasterObj.DisplayTitle !== 'null' && this.getSelectedCourseMasterObj.DisplayTitle !== '' ? this.getSelectedCourseMasterObj.DisplayTitle : null
      this.groupCourseObj.DisplaySubTitle = this.getSelectedCourseMasterObj.DisplaySubTitle !== undefined && this.getSelectedCourseMasterObj.DisplaySubTitle !== 'undefined' && this.getSelectedCourseMasterObj.DisplaySubTitle !== null && this.getSelectedCourseMasterObj.DisplaySubTitle !== 'null' && this.getSelectedCourseMasterObj.DisplaySubTitle !== '' ? this.getSelectedCourseMasterObj.DisplaySubTitle : null
      this.groupCourseObj.IsElective = this.getSelectedCourseMasterObj.IsElective
      this.completionCriteriaTextLabel = this.groupCourseObj.IsElective ? 'Allow other electives at:' : 'Completion Criteria for Electives:'
      this.groupCourseObj.DisableCertification = this.getSelectedCourseMasterObj.DisableCertification
      this.enableCertification = !this.groupCourseObj.DisableCertification
      this.groupCourseObj.AllowSelfEnrollment = this.getSelectedCourseMasterObj.AllowSelfEnrollment
      this.groupCourseObj.CompletionCriteriaForElective = this.getSelectedCourseMasterObj.CompletionCriteriaForElective !== undefined && this.getSelectedCourseMasterObj.CompletionCriteriaForElective !== 'undefined' && this.getSelectedCourseMasterObj.CompletionCriteriaForElective !== null && this.getSelectedCourseMasterObj.CompletionCriteriaForElective !== null && this.getSelectedCourseMasterObj.CompletionCriteriaForElective !== '' ? this.getSelectedCourseMasterObj.CompletionCriteriaForElective : 100
      this.groupCourseObj.EnablePersonalization = this.getSelectedCourseMasterObj.EnablePersonalization
      this.groupCourseObj.Anonymised = this.getSelectedCourseMasterObj.Anonymised
      if (this.getSelectedCourseMasterObj.SupportedPersonalizationLevels !== null && this.getSelectedCourseMasterObj.SupportedPersonalizationLevels !== 'null' && this.getSelectedCourseMasterObj.SupportedPersonalizationLevels !== undefined && this.getSelectedCourseMasterObj.SupportedPersonalizationLevels !== '') {
        if (this.checkPersonalisationLevelsOccurance('1', this.getSelectedCourseMasterObj.SupportedPersonalizationLevels)) {
          if (this.SupportedPersonalizationLevelArr.includes('1') === false) {
            this.SupportedPersonalizationLevelArr.push(1)
          }
        }
        if (this.checkPersonalisationLevelsOccurance('2', this.getSelectedCourseMasterObj.SupportedPersonalizationLevels)) {
          if (this.SupportedPersonalizationLevelArr.includes('2') === false) {
            this.SupportedPersonalizationLevelArr.push(2)
          }
        }
        if (this.checkPersonalisationLevelsOccurance('3', this.getSelectedCourseMasterObj.SupportedPersonalizationLevels)) {
          if (this.SupportedPersonalizationLevelArr.includes('3') === false) {
            this.SupportedPersonalizationLevelArr.push(3)
          }
        }
      }
      // console.log('All object' + JSON.stringify(this.getSelectedCourseMasterObj))
      this.groupCourseObj.Certificate = this.getSelectedCourseMasterObj.Certificate
      if (this.groupCourseObj.Certificate !== undefined && this.groupCourseObj.Certificate !== 'undefined' && this.groupCourseObj.Certificate !== null && this.groupCourseObj.Certificate !== 'null' && this.groupCourseObj.Certificate !== '') {
        this.enableDisableCertificationOption = this.getCertificateUrlValue !== undefined && this.getCertificateUrlValue !== 'undefined' && this.getCertificateUrlValue !== null && this.getCertificateUrlValue !== 'null' && this.getCertificateUrlValue !== ''
        this.groupCourseObj.CertificationDate = this.getCertificateObjValue.CertificationDate !== undefined && this.getCertificateObjValue.CertificationDate !== 'undefined' && this.getCertificateObjValue.CertificationDate !== null && this.getCertificateObjValue.CertificationDate !== 'null' && this.getCertificateObjValue.CertificationDate !== '' ? this.getCertificateObjValue.CertificationDate : null
        this.groupCourseObj.CertificateTitle = this.getCertificateObjValue.CertificateTitle !== undefined && this.getCertificateObjValue.CertificateTitle !== 'undefined' && this.getCertificateObjValue.CertificateTitle !== null && this.getCertificateObjValue.CertificateTitle !== 'null' && this.getCertificateObjValue.CertificateTitle !== '' ? this.getCertificateObjValue.CertificateTitle : null
        this.groupCourseObj.AllowView = this.getSelectedCourseMasterObj.AllowView
      } else {
        this.groupCourseObj.AllowView = false
      }
      this.config.defaultDate = this.formatAndShowDate(this.getSelectedCourseMasterObj.ReleaseTS)
      this.date = this.formatAndShowDate(this.getSelectedCourseMasterObj.ReleaseTS)
      if (this.getSelectedCourseMasterObj.ExpiryDays !== undefined && this.getSelectedCourseMasterObj.ExpiryDays !== null && this.getSelectedCourseMasterObj.ExpiryDays !== 'null' && this.getSelectedCourseMasterObj.ExpiryDays !== '') {
        this.groupCourseObj.ExpiryDays = this.getSelectedCourseMasterObj.ExpiryDays
      } else {
        this.groupCourseObj.ExpiryDays = 0
      }
      if (this.getSelectedCourseMasterObj.CompletionRate !== undefined && this.getSelectedCourseMasterObj.CompletionRate !== null && this.getSelectedCourseMasterObj.CompletionRate !== 'null' && this.getSelectedCourseMasterObj.CompletionRate !== '') {
        this.groupCourseObj.CompletionRate = this.getSelectedCourseMasterObj.CompletionRate
      } else {
        this.groupCourseObj.CompletionRate = 100
      }
      this.groupCourseObj.AlertMessage = this.getSelectedCourseMasterObj.AlertMessage !== undefined && this.getSelectedCourseMasterObj.AlertMessage !== null && this.getSelectedCourseMasterObj.AlertMessage !== 'null' && this.getSelectedCourseMasterObj.AlertMessage !== '' ? this.getSelectedCourseMasterObj.AlertMessage : null
    },
    formatAndShowDate: function (date) {
      if (date !== undefined && date !== null && date !== 'null' && date !== '') {
        var dateToPass = date
        if (dateToPass.indexOf('Z') === -1) {
          dateToPass += 'Z'
        }
        return dmAdminUtils.covertUtcToEst(dateToPass)
      } else {
        if (this.selectedCourseMasterObj.CourseMasterType === constants.CourseType.M365) {
          return dmAdminUtils.getCurrentEst()
        } else {
          return null
        }
      }
    },
    udpateCloseViewCourseDetailOverlay: function (event) {
      if (this.getCertificateObjValue !== undefined && this.getCertificateObjValue !== 'undefined' && this.getCertificateObjValue !== null && this.getCertificateObjValue !== 'null' && this.getCertificateObjValue !== '') {
        var certificateFile = document.getElementById('certificateFile').files[0]
        if ((this.getCertificateObjValue.CertificationDate !== undefined && this.getCertificateObjValue.CertificationDate !== null && this.getCertificateObjValue.CertificationDate !== 'null' && this.getCertificateObjValue.CertificationDate !== '') && ((certificateFile === undefined || certificateFile === 'undefined' || certificateFile === null || certificateFile === 'null' || certificateFile === '') && (this.getCertificateUrlValue === undefined || this.getCertificateUrlValue === 'undefined' || this.getCertificateUrlValue === null || this.getCertificateUrlValue === 'null' || this.getCertificateUrlValue === ''))) {
          this.showAlertDialog = true
          this.errorMsg = 'Before closing the pop-up, Please remove the certificate title and/or certification date and press update button.'
        } else {
          var objToPass = {
            closeOverlay: true,
            refreshList: false
          }
          this.$emit('closeEditGroupCourse', objToPass)
        }
      } else {
        objToPass = {
          closeOverlay: true,
          refreshList: false
        }
        this.$emit('closeEditGroupCourse', objToPass)
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    checkIsM365Course: function () {
      const courseList = this.$store.state.course_list
      var _this = this
      this.selectedCourseObj = courseList.find(function (obj) {
        return obj.CourseMasterId === _this.selectedCourseMasterObj.CourseMasterId
      })
      // console.log('this.selectedCourseObj: ' + JSON.stringify(this.selectedCourseObj))
      if (this.selectedCourseObj !== undefined && this.selectedCourseObj !== null && this.selectedCourseObj !== 'null' && this.selectedCourseObj !== '') {
        this.disableIsElectiveCheckBox = parseInt(this.selectedCourseObj.Type) === parseInt(constants.CourseType.M365)
        this.isM365Course = parseInt(this.selectedCourseObj.Type) === parseInt(constants.CourseType.M365)
      }
    },
    getCourses: function () {
      var storeObj = this.$store
      if (storeObj.state.access_token !== undefined || storeObj.state.access_token !== '' || storeObj.state.access_token !== null) {
        // AK: Check weather Course List is already present on not
        // console.log(storeObj.state.course_list.length)
        if (storeObj.state.course_list.length === 0) {
          // this.showSpinner = true
          this.$store.state.isLoading = true
        } else {
          this.checkIsM365Course()
          // this.setDefaultValues()
        }
        courseService.listCourses(storeObj.state.access_token)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store given course list
              storeObj.state.course_list = responseObj.data
              this.checkIsM365Course()
              // AK: Hide Spinner if its showing to user
              if (this.$store.state.isLoading === true) {
                // this.showSpinner = false
                this.$store.state.isLoading = false
                // this.setDefaultValues()
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if its showing to user
              if (this.$store.state.isLoading === true) {
                // this.showSpinner = false
                this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
            // AK: Hide Spinner if its showing to user
            if (this.$store.state.isLoading === true) {
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          })
      } else {
        console.log('ACCESS TOKEN IS NOT FOUND HENCE DECLINE GET COURSE LIST OPERATION')
      }
    },
    checkPersonalisationLevelsOccurance: function (stringToCheck, originalString) {
      return originalString.indexOf(stringToCheck) !== -1
    }
  },
  computed: {
    allowSelfEnrollmentValue: {
      get: function () {
        return this.groupCourseObj.AllowSelfEnrollment
      },
      set: function (newValue) {
        this.groupCourseObj.AllowSelfEnrollment = newValue
      }
    },
    setCompletionRateValue: {
      get: function () {
        return this.groupCourseObj.CompletionRate
      },
      set: function (newValue) {
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) <= 0) {
            this.showAlertDialog = true
            this.errorMsg = 'Completion Criteria for certificate can\'t be less than 1.'
            this.groupCourseObj.CompletionRate = 100
          } else if (parseInt(newValue) > 100) {
            this.showAlertDialog = true
            this.errorMsg = 'Completion Criteria for certificate can\'t be greater than 100.'
            this.groupCourseObj.CompletionRate = 100
          } else {
            this.groupCourseObj.CompletionRate = newValue
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = 'Completion Criteria for certificate can\'t be empty.'
          this.groupCourseObj.CompletionRate = 100
        }
      }
    },
    setDateValue: {
      get: function () {
        return this.date
      },
      set: function (newValue) {
        this.date = newValue
        this.config.defaultDate = newValue
        if ((this.date === null || this.date === undefined || this.date === '' || this.date === '') && this.getSelectedCourseMasterObj.CourseMasterType === constants.CourseType.M365) {
          setTimeout(() => {
            this.date = this.formatAndShowDate(this.getSelectedCourseMasterObj.ReleaseTS)
            this.config.defaultDate = this.formatAndShowDate(this.getSelectedCourseMasterObj.ReleaseTS)
          }, 10)
        }
      }
    },
    certificationDateValue: {
      get: function () {
        return this.groupCourseObj.CertificationDate
      },
      set: function (newValue) {
        this.groupCourseObj.CertificationDate = newValue
      }
    },
    certificationTitleValue: {
      get: function () {
        return this.groupCourseObj.CertificateTitle
      },
      set: function (newValue) {
        this.groupCourseObj.CertificateTitle = newValue
      }
    },
    displayTitleValue: {
      get: function () {
        return this.groupCourseObj.DisplayTitle
      },
      set: function (newValue) {
        this.groupCourseObj.DisplayTitle = newValue
      }
    },
    displaySubTitleValue: {
      get: function () {
        return this.groupCourseObj.DisplaySubTitle
      },
      set: function (newValue) {
        this.groupCourseObj.DisplaySubTitle = newValue
      }
    },
    setCompletionCriteriaForElectivesValue: {
      get: function () {
        return this.groupCourseObj.CompletionCriteriaForElective
      },
      set: function (newValue) {
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) < 0) {
            this.showAlertDialog = true
            this.errorMsg = this.completionCriteriaTextLabel + ' can\'t be less than 0.'
            this.groupCourseObj.CompletionCriteriaForElective = 100
          } else if (parseInt(newValue) > 100) {
            this.showAlertDialog = true
            this.errorMsg = this.completionCriteriaTextLabel + ' can\'t be greater than 100.'
            this.groupCourseObj.CompletionCriteriaForElective = 100
          } else {
            this.groupCourseObj.CompletionCriteriaForElective = newValue
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg = this.completionCriteriaTextLabel + ' can\'t be empty.'
          this.groupCourseObj.CompletionCriteriaForElective = 100
        }
      }
    },
    allowViewCertificateValue: {
      get: function () {
        return this.groupCourseObj.AllowView
      },
      set: function (newValue) {
        this.groupCourseObj.AllowView = newValue
      }
    },
    electiveCourseValue: {
      get: function () {
        return this.groupCourseObj.IsElective
      },
      set: function (newValue) {
        if (newValue) {
          this.groupCourseObj.AlertMessage = null
        } else {
          this.allowSelfEnrollmentValue = false
          this.groupCourseObj.AlertMessage = this.getSelectedCourseMasterObj.AlertMessage !== undefined && this.getSelectedCourseMasterObj.AlertMessage !== null && this.getSelectedCourseMasterObj.AlertMessage !== 'null' && this.getSelectedCourseMasterObj.AlertMessage !== '' ? this.getSelectedCourseMasterObj.AlertMessage : null
        }
        this.groupCourseObj.IsElective = newValue

        this.completionCriteriaTextLabel = this.groupCourseObj.IsElective ? 'Allow other electives at:' : 'Completion Criteria for Electives:'
      }
    },
    enablePersonalizationValue: {
      get: function () {
        return this.groupCourseObj.EnablePersonalization
      },
      set: function (newValue) {
        this.groupCourseObj.EnablePersonalization = newValue
      }
    },
    anonymisedValue: {
      get: function () {
        return this.groupCourseObj.Anonymised
      },
      set: function (newValue) {
        this.groupCourseObj.Anonymised = newValue
      }
    },
    personalizationLevelValue: {
      get: function () {
        return this.SupportedPersonalizationLevelArr
      },
      set: function (newValue) {
        this.SupportedPersonalizationLevelArr = newValue
      }
    },
    enableCeritificationValue: {
      get: function () {
        return this.enableCertification
      },
      set: function (newValue) {
        this.enableCertification = newValue
      }
    },
    getCertificateObjValue: {
      get: function () {
        return this.groupCourseObj.Certificate
      }
    },
    getCertificateUrlValue: {
      get: function () {
        if (this.getCertificateObjValue !== undefined && this.getCertificateObjValue !== null && this.getCertificateObjValue !== 'undefined' && this.getCertificateObjValue !== 'null' && this.getCertificateObjValue !== '') {
          return this.getCertificateObjValue.CertificateFile
        } else {
          return null
        }
      },
      set: function (newValue) {
        this.groupCourseObj.Certificate = newValue
      }
    },
    getCertificateIdValue: {
      get: function () {
        if (this.getCertificateObjValue !== undefined && this.getCertificateObjValue !== null && this.getCertificateObjValue !== 'undefined' && this.getCertificateObjValue !== 'null' && this.getCertificateObjValue !== '') {
          return this.getCertificateObjValue.CertificateId
        } else {
          return null
        }
      }
    },
    electiveAlertMessageValue: {
      get: function () {
        return this.groupCourseObj.AlertMessage
      },
      set: function (newValue) {
        this.groupCourseObj.AlertMessage = newValue
      }
    },
    expiryDaysValue: {
      get: function () {
        return this.groupCourseObj.ExpiryDays
      },
      set: function (newValue) {
        this.groupCourseObj.ExpiryDays = newValue
        var pattern = /^-?\d+\.?\d*$/
        if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
          if (parseInt(newValue) === 0) {
            if (this.getSelectedCourseMasterObj.CourseMasterType === constants.CourseType.M365) {
              this.groupCourseObj.ExpiryDays = 1
            } else {
              this.date = null
              this.config.defaultDate = null
            }
          } else if (this.date === null) {
            if (this.getSelectedCourseMasterObj.ReleaseTS !== undefined && this.getSelectedCourseMasterObj.ReleaseTS !== null && this.getSelectedCourseMasterObj.ReleaseTS !== 'null' && this.getSelectedCourseMasterObj.ReleaseTS !== '') {
              this.config.defaultDate = this.formatAndShowDate(this.getSelectedCourseMasterObj.ReleaseTS)
              this.date = this.formatAndShowDate(this.getSelectedCourseMasterObj.ReleaseTS)
            } else {
              this.config.defaultDate = dmAdminUtils.getCurrentEst()
              this.date = dmAdminUtils.getCurrentEst()
              console.log(this.date)
              console.log(this.config.defaultDate)
            }
          }
        }
      }
    },
    getSelectedCourseMasterObj: {
      get: function () {
        return this.selectedCourseMasterObj
      }
    },
    CourseTitleValue: {
      get: function () {
        return this.getSelectedCourseMasterObj.CourseTitle
      }
    },
    CourseSubTitleValue: {
      get: function () {
        return this.getSelectedCourseMasterObj.CourseSubTitle
      }
    },
    CourseVersionValue: {
      get: function () {
        var versionToShow = ''
        if (this.getSelectedCourseMasterObj.CourseMasterVersion === undefined || this.getSelectedCourseMasterObj.CourseMasterVersion === 'null' || this.getSelectedCourseMasterObj.CourseMasterVersion === null) {
          versionToShow = ''
        } else {
          versionToShow = this.getSelectedCourseMasterObj.CourseMasterVersion
        }
        return versionToShow
      }
    },
    GroupNameValue: {
      get: function () {
        return this.getSelectedCourseMasterObj.GroupName
      }
    }
  },
  watch: {
    /*
    expiryDaysValue: function (newValue, oldValue) {
      var pattern = /^-?\d+\.?\d*$/
      if (newValue !== undefined && newValue !== null && newValue !== 'null' && newValue !== '' && pattern.test(newValue)) {
        console.log(newValue)
        if (parseInt(newValue) === 0) {
          if (this.getSelectedCourseMasterObj.CourseMasterType === constants.CourseType.M365) {
            this.groupCourseObj.ExpiryDays = 1
          } else {
            this.date = null
            this.config.defaultDate = null
          }
        } else if (this.date === null) {
          if (this.getSelectedCourseMasterObj.ReleaseTS !== undefined && this.getSelectedCourseMasterObj.ReleaseTS !== null && this.getSelectedCourseMasterObj.ReleaseTS !== 'null' && this.getSelectedCourseMasterObj.ReleaseTS !== '') {
            this.config.defaultDate = this.formatAndShowDate(this.getSelectedCourseMasterObj.ReleaseTS)
            this.date = this.formatAndShowDate(this.getSelectedCourseMasterObj.ReleaseTS)
          } else {
            this.config.defaultDate = dmAdminUtils.getCurrentEst()
            this.date = dmAdminUtils.getCurrentEst()
          }
        }
      }
    },
    */
    date: function (newValue, oldValue) {
      if (newValue === undefined || newValue === null || newValue === '' || newValue === 'null') {
        this.expiryDaysValue = 0
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}
/*
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}
*/
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  /*.overlay a {
    font-size: 20px;
  }*/
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.margin-right-1Point2Perc {
  margin-right: 1.2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-17px {
  font-size: 17px !important;
}
.font-size-15px {
  font-size: 15px !important;
}
.text-align-left {
  text-align: left !important;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.course-img-width-height {
  width: 350px;
  height: 150px;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.text-color-blue {
  color: blue;
}
.text-decoration-underline {
  text-decoration: underline;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
a:link{
  color: blue !important;
  text-decoration: none !important;
}
a:visited{
  color: blue !important;
  text-decoration: none !important;
}
a:hover{
  color: blue !important;
  text-decoration: none !important;
}
a:active{
  color: blue !important;
  text-decoration: none !important;
}
a {
  color: blue !important;
  text-decoration: underline !important;
}
.border-red {
    border: 1px solid red;
}
.padding-left-0px {
    padding-left:0%;
}
.padding-right-0px {
  padding-right: 0%;
}
.tooltip1 {
    position: relative !important;
    display: inline-block !important;
    /* border-bottom: 1px dotted black !important; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    width: 90px;
    background-color: #696969;
    /* opacity:0.8; */
    color: #fff;
    text-align: left;
    border-radius: 6px;
    padding: 5px 5px;
    font-size: 12px;
    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    top: 107%;
    left: 35%;
    margin-left: -60px;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1:hover .tooltiptext1 {
    visibility: visible;
}
.height-20Px {
 height:20px;
}
.width-20Px {
  width:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/EditGroupCourseMasterOverlay.vue